import { createButton } from './buttons_utils';
import { createTooltip } from './tooltips_utils';
import { checkClipboardPermissions } from './utils';

class CopyCodeElement extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }
  async initialize() {
    const btn = createButton('Copy to clipboard', 'copy-to-clipboard');
    this.appendChild(btn);
    const tooltip = await createTooltip(btn, 'Copy to clipboard');
    this.appendChild(tooltip);
    const wrapper = this.parentNode;
    const [codeElement] = wrapper.getElementsByTagName('code');
    btn.addEventListener('click', async () => {
      const textToCopy = codeElement.innerText;
      const hasClipboardPermission = await checkClipboardPermissions();
      try {
        codeElement.dispatchEvent(new CustomEvent('copy-code-snippet', {
          bubbles: true,
          cancelable: true,
          detail: {
            code: textToCopy
          }
        }));
        if (hasClipboardPermission) {
          await navigator.clipboard.writeText(textToCopy);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Failed to copy snippet:', e);
      }
    });
  }
}

export { CopyCodeElement };
